import type { CraftingSession } from '../types/workbench'

// ONE ENTRY PER PERSON in the Crafting menu (TFY-33, Don, 2026-10-07: "there are two Carl Zimmerman's in the queue"). A session
// is one account, one person and one opportunity; a person spoken with on two opportunities is therefore two sessions, and
// the menu groups them under the one name with each conversation named beneath it. Order: the group's newest session first,
// sessions inside a group newest first. Pure.

export interface SessionGroup { key: string; sessions: CraftingSession[] }

export function groupKey(s: CraftingSession): string { return `${s.companyId}|${s.personId ?? ''}` }

export function groupSessions(sessions: CraftingSession[]): SessionGroup[] {
  const byKey = new Map<string, CraftingSession[]>()
  for (const s of sessions) {
    const k = groupKey(s)
    const list = byKey.get(k)
    if (list) list.push(s); else byKey.set(k, [s])
  }
  const groups = [...byKey.entries()].map(([key, list]) => ({ key, sessions: [...list].sort((a, b) => b.lastTurnAt.localeCompare(a.lastTurnAt)) }))
  return groups.sort((a, b) => b.sessions[0].lastTurnAt.localeCompare(a.sessions[0].lastTurnAt))
}

// AN ANSWER COUNTS AS SEEN only when the rep could see it land (2026-10-14, Don's reminder test). The workbench stamps the
// session "opened" when a reply arrives, and the reply's handler still runs after the rep has left the page for another
// screen in the app or put the tab in the background — so an answer nobody saw was being stamped as seen and the hour's
// reminder never came. Pure: the page says whether it is still mounted and what the document's visibility is.
export function answerSeen(mounted: boolean, visibility: DocumentVisibilityState): boolean {
  return mounted && visibility === 'visible'
}
